import React, { useState, useEffect } from 'react';
import { Container, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { AiOutlineDownload } from 'react-icons/ai';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

// Use public URL instead of import to avoid memfs issues
const pdfUrl = '/cv2025Nikoletta.pdf';

function ResumeNew() {
  const [width, setWidth] = useState(1200);

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  const onDocumentLoadSuccess = ({ numPages: _numPages }) => {
    // PDF loaded successfully
  };

  const onDocumentLoadError = (_error) => {
    // Handle PDF loading error - error details available for debugging
    // Error will be displayed to user via the error prop in Document component
  };

  return (
    <div>
      <Container fluid className="resume-section">
        <Row style={{ justifyContent: 'center', position: 'relative', marginTop: '20px' }}>
          <Button
            variant="primary"
            href={pdfUrl}
            target="_blank"
            style={{ maxWidth: '250px' }}
          >
            <AiOutlineDownload />
            &nbsp;Download full CV
          </Button>
        </Row>

        <Row className="resume">
          <Document
            file={pdfUrl}
            className="d-flex justify-content-center"
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={onDocumentLoadError}
            loading={<div>Loading PDF...</div>}
            error={
              <div>Failed to load PDF. Please try downloading it instead.</div>
            }
          >
            <Page pageNumber={1} scale={width > 786 ? 1.7 : 0.6} />
          </Document>
        </Row>

        <Row style={{ justifyContent: 'center', position: 'relative' }}>
          <Button
            variant="primary"
            href={pdfUrl}
            target="_blank"
            style={{ maxWidth: '250px' }}
          >
            <AiOutlineDownload />
            &nbsp;Download full CV
          </Button>
        </Row>
      </Container>
    </div>
  );
}

export default ResumeNew;
